function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.3553 24.2616C14.1315 23.5814 13.6839 22.561 13.3482 21.8808C13.1244 21.2006 12.5649 20.0669 12.5649 19.3866H38.19C38.0781 20.0669 37.5186 21.2006 37.2948 21.8808C36.9591 22.6744 36.7353 23.5814 36.2877 24.2616H14.3553ZM0.0321045 0L0.703504 1.92733C0.927304 2.60756 1.1511 3.06105 1.4868 3.74128L10.3269 26.3023C10.7745 27.436 11.1102 29.25 12.453 29.25H38.4138C39.5328 29.25 39.7566 28.1163 40.2042 27.2093L42.7779 20.5203C43.3374 19.0465 42.7779 19.3866 47.9253 19.3866C47.9253 20.1802 46.8063 22.4477 46.5825 23.1279C46.023 24.375 42.3303 33.5581 42.3303 34.0116H13.4601C13.4601 34.6919 14.2434 36.2791 14.4672 36.9593C14.9148 37.8663 15.1386 39 16.3695 39H44.1207C45.3516 39 45.6873 37.6395 46.023 36.8459L51.8418 21.9942C52.1775 21.2006 53.9679 16.7791 53.9679 16.0988C53.9679 15.4186 53.2965 14.7384 52.6251 14.625H10.5507C10.3269 13.9448 9.7674 12.811 9.5436 12.1308C9.2079 11.3372 8.9841 10.5436 8.6484 9.75H46.1349C47.0301 9.75 47.142 9.63663 47.3658 8.9564L48.9324 4.875H6.7461L4.8438 0H0.0321045Z",
  fill: "url(#paint0_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 4.35982,
  y1: 9.88122,
  x2: 49.8595,
  y2: 28.6804,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08D466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#08A652"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 39,
  fill: "white"
})));

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 39,
    viewBox: "0 0 54 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f6abb3d8.svg";
export { ForwardRef as ReactComponent };